module.exports = __webpack_public_path__ + "static/media/AnimalWelfare.d1e85b0c.svg";